var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1947_43323)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1947_43323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5542 1.5H1.49222C1.23331 1.5 1.02347 1.70984 1.02347 1.96875C1.02347 3.27411 1.58304 4.52033 2.55872 5.3876L4.6116 7.21225C4.96756 7.52866 5.17172 7.98331 5.17172 8.45966V13.0307C5.17172 13.4042 5.5892 13.6282 5.90039 13.4206L8.66593 11.577C8.7963 11.4901 8.87467 11.3438 8.87467 11.187V8.45966C8.87467 7.98331 9.07883 7.52866 9.43479 7.21225L11.4876 5.3876C12.4633 4.52033 13.0228 3.27411 13.0228 1.96875C13.0228 1.70984 12.813 1.5 12.5542 1.5ZM10.8647 4.68686L8.81195 6.5116C8.25605 7.0058 7.93717 7.71579 7.93717 8.45957V10.9362L6.10913 12.1548V8.45966C6.10913 7.71579 5.79025 7.0058 5.23435 6.5116L3.18155 4.68695C2.52365 4.10202 2.1037 3.30057 1.99127 2.43741H12.055C11.9426 3.30057 11.5227 4.10202 10.8647 4.68686Z",
    fill: "#3A3C45"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1947_43323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 -0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1947_43323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(1 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilter);
export default __webpack_public_path__ + "static/media/ic-filter.54e86f85.svg";
export { ForwardRef as ReactComponent };